import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { BEFORE_AFTER } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function BeforeAfter() {
  const [pos, setPos] = useState(50);
  const { t } = useLang();

  return (
    <section id="prima-dopo" data-testid="before-after-section" className="scroll-mt-28 bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline={t.beforeAfter.overline}
          title={t.beforeAfter.title}
          desc={t.beforeAfter.desc}
        />

        <Reveal delay={0.15} className="mt-12">
          <div className="relative aspect-[16/10] select-none overflow-hidden rounded-2xl border border-line shadow-xl shadow-slate-900/10 sm:aspect-[16/8]" data-testid="before-after-slider">
            <img src={BEFORE_AFTER.after} alt={t.beforeAfter.after} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
            <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
              <img src={BEFORE_AFTER.before} alt={t.beforeAfter.before} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
            </div>

            <span className="absolute left-4 top-4 rounded-full bg-slate-900/70 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white backdrop-blur" data-testid="before-label">
              {t.beforeAfter.before}
            </span>
            <span className="absolute right-4 top-4 rounded-full bg-brand px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white" data-testid="after-label">
              {t.beforeAfter.after}
            </span>

            <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
              <div className="absolute inset-y-0 -ml-px w-0.5 bg-white shadow-[0_0_12px_rgba(0,0,0,0.4)]" />
              <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-brand text-white shadow-lg">
                <MoveHorizontal size={18} />
              </div>
            </div>

            <input
              type="range"
              min="0"
              max="100"
              value={pos}
              onChange={(e) => setPos(Number(e.target.value))}
              className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
              aria-label={t.beforeAfter.aria}
              data-testid="before-after-range"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
